import React from 'react';

import { sanitizeAnnouncementHtml } from '@utils/miscellaneous/sanitizeAnnouncementHtml';

function Announcements({ announcements }) {
    return (
        <>
            {announcements.map(announcement => (
                <div
                    key={announcement.id}
                    className="announcement-html-content"
                    data-testid={`announcement-item-${announcement.id}`}
                    dangerouslySetInnerHTML={{
                        __html: sanitizeAnnouncementHtml(announcement.announcementText)
                    }}
                />
            ))}
        </>
    );
}

export default Announcements;
